import { createFileRoute } from '@tanstack/react-router';
import React from 'react';

import { Fade, Grid, Stack, Typography } from 'gooey';
import { PageComingSoon, PageSection } from '#/components/pages';
import { Page } from '#/components/pages/page';
import fx from '#/fx';
import { canonicalLinkTag, seo } from '#/lib/head';

import { match } from 'ts-pattern';
import { BlogPostCard } from './-components/blog-post-card';

export const Route = createFileRoute('/_main/blog/')({
  loader: async () => {
    const posts = await fx.listBlogPosts();
    return { posts };
  },
  head: ({ match }) => ({
    meta: seo({
      title: 'Blog',
      description:
        'Updates, news, and learnings to help you build ship fast AF — from the team building Joggr.',
      url: match.pathname,
    }),
    links: [canonicalLinkTag(match.pathname)],
  }),
  component: BlogPage,
});

function BlogPage() {
  const { posts } = Route.useLoaderData();
  const { featured, latest } = React.useMemo(() => {
    const featured = posts.slice(0, 2);
    const latest = posts.slice(2);
    return { featured, latest };
  }, [posts]);

  return (
    <Page>
      <PageSection>
        {match(featured)
          .when(
            (featured) => featured.length > 0,
            () => (
              <React.Fragment>
                <Stack spacing={2} className='mb-24'>
                  <div className='pb-3'>
                    <Typography variant='h1' gutterBottom>
                      Blog
                    </Typography>
                    <Typography variant='subtitle1'>
                      Updates, news, and learnings to help you ship fast AF — from the team building
                      Joggr.
                    </Typography>
                  </div>
                  <Fade in timeout={100}>
                    {(transitionProps) => (
                      <div {...transitionProps}>
                        <Grid container spacing={2}>
                          {featured.map((post) => (
                            <Grid key={post.id} size={{ xs: 12, sm: 12, md: 6 }}>
                              <BlogPostCard key={post.id} post={post} size='large' />
                            </Grid>
                          ))}
                        </Grid>
                      </div>
                    )}
                  </Fade>
                </Stack>
                {latest.length > 0 && (
                  <Fade in timeout={100}>
                    {(transitionProps) => (
                      <div {...transitionProps}>
                        <Stack spacing={2}>
                          <Typography variant='h4' component='h3'>
                            Latest Posts
                          </Typography>
                          <Grid
                            container
                            spacing={2}
                            rowSpacing={{ xs: 2, md: 4 }}
                            className='md:-mx-4'
                          >
                            {latest.map((post) => (
                              <Grid key={post.id} size={{ xs: 12, sm: 6, md: 4 }}>
                                <BlogPostCard key={post.id} post={post} size='medium' />
                              </Grid>
                            ))}
                          </Grid>
                        </Stack>
                      </div>
                    )}
                  </Fade>
                )}
              </React.Fragment>
            )
          )
          .otherwise(() => (
            <PageComingSoon className='min-h-1/2' />
          ))}
      </PageSection>
    </Page>
  );
}
